export default [
  {
    path: 'pdf-reader/:resourceId/read/:module',
    name: 'ocr-reader',
    props: true,
    component: () => import('@/views/ocr/OcrReader.vue')
  }
]
